import { __awaiter } from "tslib";
export default function retry(fn, { maxRetries = 3, onRetry = () => { }, } = {}) {
    let round = 0;
    return function retryFn(...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                round += 1;
                return yield fn(...args);
            }
            catch (err) {
                if (round < maxRetries) {
                    onRetry(round);
                    return retryFn(...args);
                }
                throw err;
            }
        });
    };
}
//# sourceMappingURL=retry.js.map